import { render, staticRenderFns } from "./link-notice.vue?vue&type=template&id=41630ee2&"
import script from "./link-notice.vue?vue&type=script&lang=js&"
export * from "./link-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports